import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isSidebarOpen: false
}

const slice = createSlice({
  name: 'sidebarPlaceholder',
  initialState,
  reducers: {
    showSidebarPlaceholder(state) {
      state.isSidebarOpen = true
    },
    hideSidebarPlaceholder(state) {
      state.isSidebarOpen = false
    },
  }
})

export const { reducer } = slice
export const { showSidebarPlaceholder, hideSidebarPlaceholder } = slice.actions
